import React, {useEffect} from 'react'
import {useParams} from "react-router";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import {connect} from "react-redux";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import DealingsService from "services/DealingsService";
import PositionAndPartsForm from "../../../../../MyProcedure/scenes/part1/panels/dealings/PositionAndPartsForm";
import RouterPath from "libs/RouterPath";
import {PurchasingGroupStageSections} from "../../../constants/PurchasingGroupStageSections";

function PurchasingGroupStage2Dealing(
    {
        panelRef,
        validationSection,
        purchasingGroupHeader,
    }) {
    const params = useParams();
    const groupId = params.id;
    const section = params.section;

    useEffect(() => {
        DealingsService.getList(groupId);
        PurchasingGroupSectionService.getSections(groupId, validationSection.section)
        return () => {
            DealingsService.clearResources('dealing');
            DealingsService.clearResources('dealingsList');
        }
        // eslint-disable-next-line
    }, [groupId])

    const saveSuccessCallback = () => {
        PurchasingGroupSectionService.getSections(groupId, [validationSection.section, PurchasingGroupStageSections.FINISH]);
        RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {
            id: groupId,
            stage: 2
        }))
    }

    const saveErrorCallback = () => {

    }


    return (<PositionAndPartsForm
        expanded
        section={validationSection}
        formId={section}
        saveErrorCallback={saveErrorCallback}
        saveSuccessCallback={saveSuccessCallback}
    />)
}

PurchasingGroupStage2Dealing.propTypes = {}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID],
    purchasingGroupHeader: state.resources[PurchasingGroupStage1Service.PURCHASING_GROUP_HEADER_RESOURCE_ID]
}), {})(PurchasingGroupStage2Dealing);